<template>
  <div class="notification-admin-filters-container">
    <div>
      <div class="notification-filter-container-left-section bg-gray">
        <div class="notification-filter-container-left-section-input">
          <input class="notifications-checkbox" id="flagged-checkbox" type="checkbox" v-model="flaggedOnly"
                 @click="flaggedOnlySelected"> Only show <b>flagged</b> notifications
        </div>
      </div>
      <!--          <div class="notification-filter-container-left-section">-->
      <!--            <input type="checkbox"> Show <b>unread</b> notifications only-->
      <!--          </div>-->
    </div>

    <div class="notification-filter-container-left-section bg-white">
      <div v-if="this.showAdminFilters">
        <div class="notification-filter-container-left-section-input" v-if="this.isInternalAdminUserRole">
          <input type="radio" id="show-my-assigned" value="assigned" v-model="showNotificationsFor">
          <label class="notification-filter-label bold" for="show-my-assigned">My Assigned Order Notifications</label>
        </div>
        <!-- Is an admin user -->
        <div class="notification-filter-container-left-section-input" v-if="this.isInternalAdminUserRole">
          <input type="radio" id="show-account-select" value="account" v-model="showNotificationsFor">
          <label class="notification-filter-label bold" for="show-account-select">Active Account Notifications</label>
          <transition name="slide">
            <v-select v-if="showNotificationsFor === 'account'"
                      :options="this.accountList"
                      v-model="this.account"
                      :clearable="false"
                      class="v-select-styling"
                      label="name"
                      placeholder="Select Account"
                      @search="onAccountSearch"
                      @input="accountSelected">
              <template slot="no-options">
                Type name or space to find accounts
              </template>
            </v-select>
          </transition>
        </div>
        <!-- Is an account mgr user -->
        <div v-else class="notification-filter-container-left-section-input">
          <input type="radio" id="show-account-select" value="account" v-model="showNotificationsFor">
          <label class="notification-filter-label bold" for="show-account-select">Company Notifications</label>
        </div>
        <div class="notification-filter-container-left-section-input">
          <input type="radio" id="show-user-select" value="user" v-model="showNotificationsFor">
          <label class="notification-filter-label bold" for="show-user-select">User Notifications</label>
          <transition name="slide">
            <v-select v-if="showNotificationsFor === 'user'"
                      :options="this.userList"
                      placeholder="All Users"
                      v-model="this.user"
                      :clearable="false"
                      class="v-select-styling"
                      label="fullname"
                      @search="onUserSearch"
                      @input="userSelected">
              <template slot="no-options">
                Type name or space to find users
              </template>
            </v-select>
          </transition>
        </div>
      </div>
      <div v-else>
        <!--You're a user!-->
      </div>
    </div>

    <div class="notification-filter-container-left-section bg-gray">
      <div class="notification-filter-container-left-section-input">
        <input id="notificationCreatedAtRange" type="radio" value="notificationCreatedAtRange"
               v-model="currentDateRangeType">
        <label class="notification-filter-label bold" for="notificationCreatedAtRange">Notification Date Range</label>
        <transition name="slide">
          <VueCtkDateTimePicker
              v-if="currentDateRangeType === 'notificationCreatedAtRange'"
              v-model="notificationCreatedAtRange"
              :custom-shortcuts='dataShortcuts'
              :range="true"
              id="created-at-range"
              color="#005288"
              button-color="#005288"
              formatted="YYYY-MM-DD"
              format="YYYY-MM-DD"
              :auto-close="true"
              :no-button="true"
              :only-date="true"
              :no-label="true"
              :no-clear-button="true"
              input-size="sm"
          />
        </transition>
      </div>

      <div class="notification-filter-container-left-section-input">
        <input id="orderDueDateRange" type="radio" value="orderDueDateRange" v-model="currentDateRangeType">
        <label class="notification-filter-label bold" for="orderDueDateRange">Order Due Date Range</label>
        <transition name="slide">
          <VueCtkDateTimePicker
              v-model="orderDueDateRange"
              v-if="currentDateRangeType === 'orderDueDateRange'"
              :custom-shortcuts='dataShortcuts'
              :range="true"
              color="#005288"
              id="due-at-range"
              button-color="#005288"
              formatted="YYYY-MM-DD"
              format="YYYY-MM-DD"
              :auto-close="true"
              :no-button="true"
              :only-date="true"
              :no-label="true"
              :no-clear-button="true"
              input-size="sm"
          />
        </transition>
      </div>

      <div class="notification-filter-container-left-section-input">
        <div class="notification-admin-selection-container">
          <div class="select-type-container">
            <div class="notification-filter-label bold">Select Type</div>
            <div v-if="this.notificationType.key !== 'all'" class="clickable acclaro-blue"
                 @click="clearType">
              clear
            </div>
          </div>
          <v-select :options="types"
                    v-model="notificationType"
                    class="v-select-styling"
                    label="label"
                    :clearable="false"
                    @input="typeSelected">
          </v-select>
        </div>
      </div>
    </div>
    <div v-if="!this.hideClearFilters" class="notification-filter-container-left-section bg-white">
      <div class="notification-filter-container-left-section-input">
        <div class="notification-filter-container-footer">
          <a href="#" @click="resetFilter">Reset all filters</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './user-notifications.scss';
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import {debounce} from "lodash";
import axios from "axios";

const TYPE_ALL = {'label': 'All', 'key': 'all'};

export default {
  name: "notification-filters-left-panel.vue",
  props: ['isAdminUser'],
  data () {
    return {
      'types': [
        TYPE_ALL,
        {'label': 'Order', 'key': 'order'},
        {'label': 'File', 'key': 'file'},
        {'label': 'Invoice', 'key': 'invoice'},
        {'label': 'Review', 'key': 'review'},
        {'label': 'User', 'key': 'user'},
      ],
      'dataShortcuts': [
        {key: 'today', label: 'Today', value: '-day'},
        {key: 'thisWeek', label: 'This week', value: 'isoWeek'},
        {key: 'Month', label: 'Past month', value: '-month'},
        {key: 'thisMonth', label: 'This month', value: 'month'},
        {key: 'lastThreeMonths', label: 'This quarter', value: 90},
        {key: 'thisYear', label: 'This year', value: 'year'},
        {key: 'pastYear', label: 'Past year', value: 365},
      ],
    };
  },
  computed: {
    ...mapState('PortalNotificationStore', [
      'unreadCount',
      'notifications',
      'user',
      'account',
      'accountList',
      'userList',
      'notificationType',
      'loading',
      'error',
      'showNotificationsFor',
      'notificationCreatedAtRange',
      'orderDueDateRange',
      'assignedOnly',
      'flaggedOnly',
    ]),
    ...mapState('AuthStore', {
      sessionUser: 'user',
      sessionAccount: 'account',
      sessionRole: 'role'
    }),
    ...mapGetters('PortalNotificationStore', ['requestUrl', 'hideClearFilters']),
    ...mapGetters('AuthStore', {
      "isExternalAccountManagerRole": "isAccountManagerRole",
      "isInternalAdminUserRole": "isAdminUser"
    }),
    showAdminFilters () {
      return this.isInternalAdminUserRole || this.isExternalAccountManagerRole;
    },
    notificationCreatedAtRange: {
      get () {
        return this.$store.state.PortalNotificationStore.notificationCreatedAtRange;
      },
      set (value) {
        this.setNotificationCreatedAtRange(value);
        if (this.notificationCreatedAtRange.start && this.notificationCreatedAtRange.end) {
          this.fetchNotifications(this.requestUrl);
        }
      }
    },
    orderDueDateRange: {
      get () {
        return this.$store.state.PortalNotificationStore.orderDueDateRange;
      },
      set (value) {
        this.setOrderDueDateRange(value);
        if (this.orderDueDateRange.start && this.orderDueDateRange.end) {
          this.fetchNotifications(this.requestUrl);
        }
      }
    },
    currentDateRangeType: {
      get () {
        return this.$store.state.PortalNotificationStore.currentDateRangeType;
      },
      set (value) {
        this.setCurrentDateRangeType(value);
        if (this.orderDueDateRange.start && this.orderDueDateRange.end) {
          this.fetchNotifications(this.requestUrl);
        }
      }
    },
    showNotificationsFor: {
      get () {
        return this.$store.state.PortalNotificationStore.showNotificationsFor;
      },
      set (value) {
        this.setShowNotificationsFor(value);
        this.setAssignedOnly(value === 'assigned');
        this.fetchNotifications(this.requestUrl);
      }
    }
  },
  methods: {
    ...mapActions('PortalNotificationStore', [
      "fetchNotifications",
      "loadAccountData",
      "loadViewableUsers"
    ]),
    ...mapMutations('PortalNotificationStore', [
      'setAccount',
      'setUser',
      'setShowNotificationsFor',
      'setUserList',
      'setNotificationType',
      'setAccountList',
      'setNotificationCreatedAtRange',
      'setAssignedOnly',
      'setDisplayAccountColumn',
      "setCurrentPage",
      "toggleFlaggedOnly",
      "setSearchTerm",
      "setOrderDueDateRange",
      "setCurrentPage",
      "setCurrentDateRangeType"
    ]),
    clearType () {
      this.setCurrentPage({
        url: undefined, //unused
        page: 1
      });
      this.setNotificationType(TYPE_ALL);
      this.fetchNotifications(this.requestUrl);
    },
    typeSelected (type) {
      this.setCurrentPage({
        url: undefined, //unused
        page: 1
      });
      this.setNotificationType(type);
      this.fetchNotifications(this.requestUrl);
    },
    accountSelected (value) {
      this.setAccount(value);
      this.setCurrentPage({
        url: undefined, //unused
        page: 1
      });
      this.setShowNotificationsFor('account');
      this.fetchNotifications(this.requestUrl);
    },
    onUserSearch (search, loading) {
      if (search.length) {
        loading(true);
        this.searchUsers(loading, search, this);
      }
    },
    searchUsers: debounce((loading, search, vm) => {
      const getUsersURL = new URL(window.location.origin + '/permissions/can-view/users');
      getUsersURL.searchParams.append("search", search);
      if (vm.isInternalAdminUserRole) {
        getUsersURL.searchParams.append("with_account_name", "1");
      }
      axios.get(getUsersURL.href).then(res => {
        vm.setUserList(res.data);
        loading(false);
      });
    }, 500),
    onAccountSearch (search, loading) {
      if (search.length) {
        loading(true);
        this.searchAccounts(loading, search, this);
      }
    },
    searchAccounts: debounce((loading, search, vm) => {
      axios.get(
          `/accounts/all?search=${escape(search)}`
      ).then(res => {
        vm.setAccountList(res.data);
        loading(false);
      });
    }, 500),
    userSelected (value) {
      this.setUser(value);
      this.setCurrentPage({
        url: undefined, //unused
        page: 1
      });
      this.setShowNotificationsFor('user');
      this.fetchNotifications(this.requestUrl);
    },
    resetFilter () {
      location.reload();
    },
    flaggedOnlySelected () {
      this.toggleFlaggedOnly();
      this.fetchNotifications(this.requestUrl);
    },
  },
};
</script>
